// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"636":"landing","806":"user","976":"share"}[chunkId] || chunkId) + "." + __webpack_require__.h().slice(0, 8) + ".bundle.js";
};